import axios from "axios";
import React, { useEffect, useState } from "react";
import PhoneInput, { formatPhoneNumberIntl } from "react-phone-number-input";
import { CountryDropdown } from "react-country-region-selector";

import "react-phone-number-input/style.css";

const PersonalProfileForm = ({ data, token }) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [officeName, setOfficeName] = useState("");
  const [flat, setFlat] = useState("");
  const [village, setVillage] = useState("");
  const [street, setStreet] = useState("");
  const [area, setArea] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [adharNumber, setAdharNumber] = useState("");
  const [DOB, setDOB] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [phone, setPhone] = useState();

  const [editProfile, setEditProfile] = useState(false);

  useEffect(() => {
    if (data) {
      const parsedAddressObj = JSON.parse(data.personal_address);
      setFirstName(data.name.split(" ")[0]);
      setLastName(data.name.split(" ")[1] ? data.name.split(" ")[1] : "");
      setEmail(data.email);
      setZipCode(data.zipCode);
      setAdharNumber(data.adharNumber);

      setOfficeName(parsedAddressObj.officeName);
      setFlat(parsedAddressObj.flat);
      setVillage(parsedAddressObj.village);
      setStreet(parsedAddressObj.street);
      setArea(parsedAddressObj.area);
      setCity(parsedAddressObj.city);
      setState(parsedAddressObj.state);
      setCountry(parsedAddressObj.country);

      setDOB(data.DOB);
      setCountryCode(data.country_code);
      setPhone(data.phone_num);
    }
  }, [data]);

  const handleSubmit = () => {
    const address = {
      officeName,
      flat,
      village,
      street,
      area,
      city,
      state,
      country,
    };

    const data = {
      name: firstName + " " + lastName,
      email,
      phone: phone ? formatPhoneNumberIntl(phone) : "",
      country_code: formatPhoneNumberIntl(phone).split(" ")[0],
      personal_address: JSON.stringify(address),
      DOB,
      adharNumber,
      zipCode,
    };

    axios
      .post(
        `https://server.abnca.in/users/personalProfile/update`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        }
      )
      .then((res) => {
        window.alert(res.data.message);
        window.location.reload();
        if (res.data.status === 400) {
          if (res.data.message) {
            window.alert(res.data.message);
            window.location.reload();
          }
        }
      })
      .catch((err) => {
        window.alert("some error occured please check console");
        console.log(err);
      });
  };

  return (
    <div className="px-3 pb-5">
      <div className="d-flex justify-content-between align-items-center">
        <h4 className="text-right">Personal Profile</h4>
      </div>
      <div className="row mt-2">
        <div className="col-md-6">
          <label className="labels">First name</label>
          <input
            type="text"
            className="form-control"
            placeholder="First name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            disabled={!editProfile}
          />
        </div>
        <div className="col-md-6">
          <label className="labels">Last Name</label>
          <input
            type="text"
            className="form-control"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            placeholder="Last name"
            disabled={!editProfile}
          />
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-md-12">
          <label className="labels">Email ID</label>
          <input
            type="text"
            className="form-control"
            placeholder="Email id"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={true}
          />
        </div>
        <div className="col-md-12 mt-3">
          <label className="labels">Phone Number</label>
          <PhoneInput
            placeholder="Enter phone number"
            value={phone}
            onChange={setPhone}
            className="form-control"
            defaultCountry="IN"
            countryOptionsOrder={["IN", "🌐", "AU", "SG", "AE", "GB", "US"]}
            disabled={!editProfile}
          />
        </div>
        <div className="col-md-12 mt-3">
          <label className="labels">Date of Birth</label>
          <input
            type="date"
            className="form-control"
            placeholder="Date of birth"
            value={DOB}
            onChange={(e) => setDOB(e.target.value)}
            disabled={!editProfile}
          />
        </div>
        <div className="col-md-12 mt-3">
          <label className="labels">Name Of Office</label>
          <input
            type="text"
            className="form-control"
            placeholder="Name of office"
            value={officeName}
            onChange={(e) => setOfficeName(e.target.value)}
            disabled={!editProfile}
          />
        </div>
        <div className="col-md-12 mt-3">
          <label className="labels">Flat/Room/Door/Block No</label>
          <input
            type="text"
            className="form-control"
            placeholder="flat/Room/Door/Block No"
            value={flat}
            onChange={(e) => setFlat(e.target.value)}
            disabled={!editProfile}
          />
        </div>
        <div className="col-md-12 mt-3">
          <label className="labels">Name of Permisis/Building/Village</label>
          <input
            type="text"
            className="form-control"
            placeholder="Name of Permisis/Building/Village"
            value={village}
            onChange={(e) => setVillage(e.target.value)}
            disabled={!editProfile}
          />
        </div>
        <div className="col-md-12 mt-3">
          <label className="labels">Road/Street/Lane/Post office</label>
          <input
            type="text"
            className="form-control"
            placeholder="Road/Street/Lane/Post office"
            value={street}
            onChange={(e) => setStreet(e.target.value)}
            disabled={!editProfile}
          />
        </div>
        <div className="col-md-12 mt-3">
          <label className="labels">Area/Locality/Taluka/Sub-division</label>
          <input
            type="text"
            className="form-control"
            placeholder="Area/Locality/Taluka/Sub-division"
            value={area}
            onChange={(e) => setArea(e.target.value)}
            disabled={!editProfile}
          />
        </div>
        <div className="col-md-12 mt-3">
          <label className="labels">Town/City/District</label>
          <input
            type="text"
            className="form-control"
            placeholder="Town/City/District"
            value={city}
            onChange={(e) => setCity(e.target.value)}
            disabled={!editProfile}
          />
        </div>
        <div className="col-md-12 mt-3">
          <label className="labels">State/Union Territory</label>
          <input
            type="text"
            className="form-control"
            placeholder="State/Union Territory"
            value={state}
            onChange={(e) => setState(e.target.value)}
            disabled={!editProfile}
          />
        </div>
        <div className="col-md-12 mt-3">
          <label className="labels">Zip Code</label>
          <input
            type="text"
            className="form-control"
            placeholder="Zip Code"
            value={zipCode}
            onChange={(e) => setZipCode(e.target.value)}
            disabled={!editProfile}
          />
        </div>
        <div className="col-md-12 mt-3">
          <label className="labels">Country</label>
          <CountryDropdown
            classes="form-control"
            value={country}
            onChange={(val) => setCountry(val)}
            disabled={!editProfile}
          />
        </div>
        <div className="col-md-12 mt-3">
          <label className="labels">Adhar Number</label>
          <input
            type="text"
            className="form-control"
            placeholder="Adhar Number"
            value={adharNumber}
            onChange={(e) => setAdharNumber(e.target.value)}
            disabled={!editProfile}
          />
        </div>
      </div>
      <div className="mt-5 text-center">
        {editProfile ? (
          <>
            <button
              className="btn btn-primary profile-button"
              type="button"
              onClick={handleSubmit}
            >
              Update Personal Profile
            </button>
            <button
              className="btn btn-danger ml-4 profile-button"
              type="button"
              onClick={() => setEditProfile(false)}
            >
              Cancel
            </button>
          </>
        ) : (
          <button
            className="btn btn-primary profile-button"
            type="button"
            onClick={() => setEditProfile(true)}
          >
            Edit Personal Profile
          </button>
        )}
      </div>
    </div>
  );
};

export default PersonalProfileForm;
